import { FormGroup, FormControl, Validators, FormGroupDirective } from '@angular/forms';
import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'payment-info-modal',
  templateUrl: './payment-info-modal.component.html',
  styles: []
})
export class PaymentInfoModalComponent implements OnInit {
  @ViewChild('docPaymentForm') docPaymentForm: FormGroupDirective;
  @Input() paymentInfo;
  submitType: string = "invoice";
  submitted: boolean = false;
  paymentForm = new FormGroup({
    name: new FormControl('', [Validators.required]),
    iban: new FormControl('', [Validators.required]),
    account_number: new FormControl('', [Validators.required]),
    bank_name: new FormControl('', [Validators.required]),
    country: new FormControl('', [Validators.required])
  });

  constructor(public activeModal: NgbActiveModal, private el: ElementRef) {
    el.nativeElement.id = 'invoiceTerms';
  }

  ngOnInit() {
    if (this.paymentInfo && Object.keys(this.paymentInfo).length) {
      this.paymentForm.patchValue(this.paymentInfo);
    }
  }

  submit() {
    let fd: any = {
      formData: this.paymentForm.value,
      submit_type: this.submitType
    }

    this.activeModal.close(fd);
  }

}
